import {type ParsedUrlQuery} from 'querystring';

const extractOverrides = (
  query: ParsedUrlQuery,
  prefix: string,
  formatter: (x: string) => any = x => x
) => {
  const matcher = new RegExp(`^${prefix}\\[(?<name>.+)\\]$`);
  return Object.entries(query).reduce((overrides, [queryParamName, queryParamValue]) => {
    const match = matcher.exec(queryParamName);
    if (match?.groups?.name) {
      return {
        ...overrides,
        [match.groups.name]: formatter(queryParamValue as string),
      };
    }
    return overrides;
  }, {} as Record<string, any>);
};

export default extractOverrides;
